
import { CommonModule } from '@angular/common';
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        IonicModule
    ],
    templateUrl: './cookies-policy.component.html',
    styleUrls: ['./cookies-policy.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
})

export class CookiesPolicyComponent {
    private modalController: ModalController = inject(ModalController);
    
    dismissModal(){
        this.modalController.dismiss();
    }
}